import React from 'react'
import { useTranslation } from 'react-i18next'
import Box from '@node-space/storybook-components/dist/Box'
import { Button } from '@node-space/storybook-components/dist/Button'
import { Icon } from '@node-space/storybook-components/dist/Icon'
import { Text } from '@node-space/storybook-components/dist/Text'

export const FileUpload = () => {
  const { t } = useTranslation()

  return (
    <Box>
      <Text size="sm" color="grey">
        {t('massPayouts.dragFileToUpload')}
        <Button
          noStyling
          className="ml-2 align-bottom text-primary-500"
          iconElement={<Icon color="primary-500" name="ImageIcon" />}
        >
          {t('massPayouts.browseFiles')}
        </Button>
      </Text>
    </Box>
  )
}
